<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/style/index.less";
</style>


<style lang="less" >
.scroll-list::-webkit-scrollbar {
  width: 5px;
  height: 0;
}
.scroll-list::-webkit-scrollbar-track {
  border-radius: 2px;
}
.scroll-list::-webkit-scrollbar-thumb {
  background-color: #dde3eb;
  border-radius: 5px;
  width: 5px;
}
:root {
	--el-text-color-regular: #233558 !important;
	--el-color-primary: #5666ff !important;
	--el-color-primary-light-3: #5666ffb3 !important;
	--el-color-primary-light-5: #c8c8c8 !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color: #5666ff !important;
}

</style>


// WEBPACK FOOTER //
// src/App.vue